export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";